module.exports = __webpack_public_path__ + "static/mountain-right-9b4562598149a3574f6f06549c5fac9f.webp";